import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { parseISODate } from '../../containers/VisitsAvailability/utils';

export function monkeyPatchIntlContext(intl) {
  const _formatDate = intl.formatDate;
  const _formatTime = intl.formatTime;
  intl.formatDate = (value, options) => {
    if (typeof value === 'string') {
      return _formatDate(parseISODate(value), options);
    }
    return _formatDate(value, options);
  };
  intl.formatTime = (value, options) => {
    if (typeof value === 'string') {
      return _formatTime(parseISODate(value), options);
    }
    return _formatTime(value, options);
  };
}

class MonkeyPatch extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatDate: PropTypes.func.isRequired,
      formatTime: PropTypes.func.isRequired,
    }).isRequired,
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    monkeyPatchIntlContext(props.intl);
  }

  render() {
    return this.props.children;
  }
}

export default injectIntl(MonkeyPatch);
